import React from "react";

import ContentCard from "../../../../UI/ContentCard/ContentCard";
import premiseImg from "../../../../assests/images/premise.png";

const Premise = () => (
  <ContentCard
    title="THE PREMISE"
    id="idea"
    image={premiseImg}
    imageTtitle="premise"
    frontText="We are aiming to produce perfect products within a reasonable price range, under fair production circumstances."
    backTextOne="We are aiming to produce perfect products within a reasonable price range and under fair humane production circumstances.
          We will not put a product on the market that we do not consider to be perfectly produced. Together with the SAMPELL community
          we will continiously increase the level of perfection of our products.  We have a unisex policy and tolerate anything accept intolerance.
          We care about a respectful and fair interaction with everybody - customers, workers, business partners.  The same applies in return when
          interacting with us. For us money is not everything. We do not allow interaction, business or selling of our products when we are aware that
          there is a lack of respect, tolerance and fairness against SAMPELL or others."
  />
);

export default Premise;



// WEBPACK FOOTER //
// ./src/components/Pages/Progress/Content/Premise.js